



class Tools {
    constructor() {
        this.initjQuery();
    }

    initjQuery() {

        $.fn.extend({
            spinner(param) {
                this._spinnerStart = function () {
                    for (let i = 0; i < this.length; i++) {
                        const $button = $(this[i]);
                        if (typeof $button.data('spinner') == 'undefined' || !$button.data('spinner').spinning) {
                            $button.data('spinner', {
                                html: $button.html(),
                                spinning: true
                            })
                                .html('<div class="spinner"><div class="spinner__item1"></div><div class="spinner__item2"></div><div class="spinner__item3"></div></div>')
                                .addClass('no-events');
                        }
                    }
                };
                this._spinnerEnd = function () {
                    for (let i = 0; i < this.length; i++) {
                        const $button = $(this[i]);

                        if (typeof $button.data('spinner') !== 'undefined' && $button.data('spinner').spinning) {
                            $button
                                .html($button.data('spinner').html)
                                .removeClass('no-events');
                            $button.data().spinner.spinning = false;
                        }
                    }
                };
                this._spinnerToggle = function () {
                    for (let i = 0; i < this.length; i++) {
                        const $button = $(this[i]);
                        if (typeof $button.data('spinner') !== 'undefined' && $button.data('spinner').spinning) {
                            this._spinnerEnd();
                        }
                        else {
                            this._spinnerStart();
                        }
                    }
                };
                switch (param) {
                    case 'start':
                        this._spinnerStart();
                        break;
                    case 'end':
                        this._spinnerEnd();
                        break;
                    case 'stop':
                        this._spinnerEnd();
                        break;
                    default:
                        this._spinnerToggle();
                }
                return this;
            }
        });

        $.fancybox = {
            open(p) {
                const params = {
                    type: 'inline',
                    href: '',
                    content: '',
                    beforeClose() {
                    },
                    beforeLoad() {
                    },
                    afterLoad() {
                    },
                };
                $.extend(params, p[0]);
                const isTechnical = params.content.indexOf('TECHNICAL ERROR') !== -1;
                if (isTechnical) {
                    try {
                        console.trace('TECHNICAL ERROR');
                    }
                    catch (err) {
                        console.warn('TECHNICAL ERROR');
                    }
                }

                switch (params.type) {
                    case 'iframe':
                        import(/* webpackChunkName: "popup" */'../components/popup').then(({ default: Popup }) => new Popup({
                            type: 'success',
                            content: `<iframe src="${params.href}" style="width: 100%; max-width: ${params.width}px; height: ${params.height}px;" frameborder="0"></iframe>`,
                            callbacks: {
                                close() {
                                    params.beforeClose();
                                },
                                open() {
                                    const $content = $('#targetThird .content');
                                    $content.addClass('loading');
                                    $content.find('iframe').on('load', () => {
                                        $content.removeClass('loading');
                                    });
                                }
                            }
                        }));
                        break;

                    case 'image':

                        break;
                    case 'ajax':
                        params.beforeLoad();
                        $.ajax({
                            type: 'POST',
                            headers: { 'cache-control': 'no-cache' },
                            url: params.href,
                            async: true,
                            cache: false,
                            success(data) {
                                params.afterLoad(data);
                                import(/* webpackChunkName: "popup" */'../components/popup').then(({ default: Popup }) => new Popup({
                                    type: 'success',
                                    content: data,
                                    callbacks: {
                                        close() {
                                            params.beforeClose();
                                        }
                                    }
                                }));
                            },
                            error() {
                                import(/* webpackChunkName: "popup" */'../components/popup').then(({ default: Popup }) => new Popup({
                                    type: 'error',
                                    content: KLIP_TECH_ERROR,
                                    callbacks: {}
                                }));
                                try {
                                    console.trace(`Server error at ${params.href}`);
                                }
                                catch (err) {
                                    console.warn('TECHNICAL ERROR');
                                }
                            }
                        });
                        break;
                    default:
                        import(/* webpackChunkName: "popup" */'../components/popup').then(({ default: Popup }) => new Popup({
                            type: 'error',
                            content: isTechnical ? KLIP_TECH_ERROR : params.content,
                            callbacks: {
                                close() {
                                    params.beforeClose();
                                }
                            }
                        }));
                }
            },
            defaults: {}
        };
        $.fn.fancybox = function (params) {
            this.each((key, element) => {
                $(element).on('click', e => {
                    e.preventDefault();

                    const p = $.extend({}, params);
                    if (typeof p.href == 'undefined') {
                        p.href = $(element).attr('href');
                    }

                    $.fancybox.open([p]);
                });
            });

            return this;
        };

        const dataOriginal = $.fn.data;

        $.fn.data = function (...args) {
            if (args[0] && !args[1] && this[0] && this[0].data && this[0].data[args[0]]) {
                return this[0].data[args[0]];
            }
            else if (!args[0] && !args[1] && this[0] && this[0].data) {
                return { ...this[0].data, ...dataOriginal.apply(this, args) };
            }

            return dataOriginal.apply(this, args);
        };
    }

    formatCurrency(price, currencyFormat, currencySign, currencyBlank) {
        // if you modified this function, don't forget to modify the PHP function displayPrice (in the Tools.php class)
        let blank = '';
        price = parseFloat(price).toFixed(10);
        price = this.ps_round(price, priceDisplayPrecision);
        if (currencyBlank > 0) {
            blank = ' ';
        }
        if (currencyFormat == 1) {
            return currencySign + blank + this.formatNumber(price, priceDisplayPrecision, ',', '.');
        }
        if (currencyFormat == 2) {
            return (this.formatNumber(price, priceDisplayPrecision, ' ', ',') + blank + currencySign);
        }
        if (currencyFormat == 3) {
            return (currencySign + blank + this.formatNumber(price, priceDisplayPrecision, '.', ','));
        }
        if (currencyFormat == 4) {
            return (this.formatNumber(price, priceDisplayPrecision, ',', '.') + blank + currencySign);
        }
        if (currencyFormat == 5) {
            return (currencySign + blank + this.formatNumber(price, priceDisplayPrecision, '\'', '.'));
        }
        return price;
    }

    formatNumber(value, numberOfDecimal, thousenSeparator, virgule) {
        value = value.toFixed(numberOfDecimal);
        const val_string = `${value}`;
        const tmp = val_string.split('.');
        let abs_val_string = (tmp.length === 2) ? tmp[0] : val_string;
        const deci_string = (`0.${tmp.length === 2 ? tmp[1] : 0}`).substr(2);
        const nb = abs_val_string.length;

        for (let i = 1; i < 4; i++) {
            if (value >= Math.pow(10, (3 * i))) {
                abs_val_string = abs_val_string.substring(0, nb - (3 * i)) + thousenSeparator + abs_val_string.substring(nb - (3 * i));
            }
        }

        if (parseInt(numberOfDecimal, 10) === 0) {
            return abs_val_string;
        }
        return abs_val_string + virgule + (deci_string > 0 ? deci_string : '00');
    }

    ps_round(value, places) {
        if (typeof (roundMode) === 'undefined') {
            roundMode = 2;
        }
        if (typeof (places) === 'undefined') {
            places = 2;
        }

        const method = roundMode;

        if (method === 0) {
            return this.ceilf(value, places);
        }
        else if (method === 1) {
            return this.floorf(value, places);
        }
        else if (method === 2) {
            return this.ps_round_half_up(value, places);
        }
        else if (method == 3 || method == 4 || method == 5) {
            // From PHP Math.c
            const precision_places = 14 - Math.floor(this.ps_log10(Math.abs(value)));
            const f1 = Math.pow(10, Math.abs(places));

            if (precision_places > places && precision_places - places < 15) {
                let f2 = Math.pow(10, Math.abs(precision_places));
                if (precision_places >= 0) {
                    tmp_value = value * f2;
                }
                else {
                    tmp_value = value / f2;
                }

                tmp_value = ps_round_helper(tmp_value, roundMode);

                /* now correctly move the decimal point */
                f2 = Math.pow(10, Math.abs(places - precision_places));
                /* because places < precision_places */
                tmp_value /= f2;
            }
            else {
                /* adjust the value */
                if (places >= 0) {
                    tmp_value = value * f1;
                }
                else {
                    tmp_value = value / f1;
                }

                if (Math.abs(tmp_value) >= 1e15) {
                    return value;
                }
            }

            tmp_value = ps_round_helper(tmp_value, roundMode);
            if (places > 0) {
                tmp_value /= f1;
            }
            else {
                tmp_value *= f1;
            }

            return tmp_value;
        }
        return false;
    }

    ceilf(value, precision) {
        if (typeof (precision) === 'undefined') {
            precision = 0;
        }
        const precisionFactor = precision === 0 ? 1 : Math.pow(10, precision);
        const tmp = value * precisionFactor;
        const tmp2 = tmp.toString();
        if (tmp2[tmp2.length - 1] === 0) {
            return value;
        }
        return Math.ceil(value * precisionFactor) / precisionFactor;
    }

    floorf(value, precision) {
        if (typeof (precision) === 'undefined') {
            precision = 0;
        }
        const precisionFactor = precision === 0 ? 1 : Math.pow(10, precision);
        const tmp = value * precisionFactor;
        const tmp2 = tmp.toString();
        if (tmp2[tmp2.length - 1] === 0) {
            return value;
        }
        return Math.floor(value * precisionFactor) / precisionFactor;
    }

    ps_round_half_up(value, precision) {
        const mul = Math.pow(10, precision);
        let val = value * mul;

        const next_digit = Math.floor(val * 10) - 10 * Math.floor(val);
        if (next_digit >= 5) {
            val = Math.ceil(val);
        }
        else {
            val = Math.floor(val);
        }

        return val / mul;
    }

    ps_log10(value) {
        return Math.log(value) / Math.LN10;
    }

    ps_round_helper(value, mode) {
        // From PHP Math.c
        if (value >= 0.0) {
            tmp_value = Math.floor(value + 0.5);
            if ((mode == 3 && value == (-0.5 + tmp_value)) ||
            (mode == 4 && value == (0.5 + 2 * Math.floor(tmp_value / 2.0))) ||
            (mode == 5 && value == (0.5 + 2 * Math.floor(tmp_value / 2.0) - 1.0))) {
                tmp_value -= 1.0;
            }
        }
        else {
            tmp_value = Math.ceil(value - 0.5);
            if ((mode == 3 && value == (0.5 + tmp_value)) ||
            (mode == 4 && value == (-0.5 + 2 * Math.ceil(tmp_value / 2.0))) ||
            (mode == 5 && value == (-0.5 + 2 * Math.ceil(tmp_value / 2.0) + 1.0))) {
                tmp_value += 1.0;
            }
        }

        return tmp_value;
    }

    getMobileOperatingSystem() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }

        if (/android/i.test(userAgent)) {
            return 'Android';
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 'iOS';
        }

        return 'unknown';
    }

    emptyCustomizations() {
        customizationId = null;
        if (typeof (customizationFields) === 'undefined') return;

        $('.customization_block .success').fadeOut(function () {
            $(this).remove();
        });
        $('.customization_block .error').fadeOut(function () {
            $(this).remove();
        });
        for (let i = 0; i < customizationFields.length; i++) {
            $(`#${customizationFields[i][0]}`).html('');
            $(`#${customizationFields[i][0]}`).val('');
        }
    }

    checkCustomizations() {
        const pattern = new RegExp(' ?filled ?');

        if (typeof customizationFields !== 'undefined') {
            for (let i = 0; i < customizationFields.length; i++) {
                /* If the field is required and empty then we abort */
                if (parseInt(customizationFields[i][1]) == 1 && ($(`#${customizationFields[i][0]}`).html() == '' || $(`#${customizationFields[i][0]}`).text() != $(`#${customizationFields[i][0]}`).val()) && !pattern.test($(`#${customizationFields[i][0]}`).attr('class'))) {
                    return false;
                }
            }
        }
        return true;
    }

    declension(sk, vienetai, desimtys, kita) {
        let rezultatas;
        if ((sk % 10 === 1) && (sk % 100 !== 11)) {
            rezultatas = vienetai;
        }
        else if (((sk % 10 === 0)) || ((sk % 100 <= 20) && (sk % 100 >= 10))) {
            rezultatas = desimtys;
        }
        else {
            rezultatas = kita;
        }
        return rezultatas;
    }

    utf8_decode(utfstr) {
        let res = '';
        for (let i = 0; i < utfstr.length;) {
            const c = utfstr.charCodeAt(i);

            if (c < 128) {
                res += String.fromCharCode(c);
                i++;
            }
            else if ((c > 191) && (c < 224)) {
                const c1 = utfstr.charCodeAt(i + 1);
                res += String.fromCharCode(((c & 31) << 6) | (c1 & 63));
                i += 2;
            }
            else {
                const c1 = utfstr.charCodeAt(i + 1);
                const c2 = utfstr.charCodeAt(i + 2);
                res += String.fromCharCode(((c & 15) << 12) | ((c1 & 63) << 6) | (c2 & 63));
                i += 3;
            }
        }
        return res;
    }
}

const tools = new Tools();

export default tools;
